import React, { useMemo } from 'react';
import { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import { styled, Box } from '@material-ui/core';

import { Caption } from './Caption';

const Image = styled('img')({
  width: 'auto',
  height: 260,
  display: 'inline',
  maxWidth: '100%',
  margin: 'auto',
  ['@media (min-width: 768px)']: {
    height: 500,
  },
  ['@media (min-width: 992px)']: {
    height: 600,
  },
});

const StyledSwiper = styled(Swiper)(({ theme }) => ({
  '& .swiper-pagination': {
    position: 'static',
    marginTop: 30,
  },
  '& .swiper-pagination-bullet': {
    width: '10px',
    height: '10px',
    display: 'inline-block',
    borderRadius: '50%',
    backgroundColor: '#979797',
    margin: '0 8px',
    opacity: 0.3,
  },
  '& .swiper-pagination-bullet.swiper-pagination-bullet-active': {
    width: '12px',
    height: '12px',
    backgroundColor: '#e30613',
    // backgroundColor: '#EC0E00',
    opacity: 1,
  },
  '& .swiper-button-prev': {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    width: 40,
    height: 40,
    left: 'auto',
    top: 20,
    right: 40,
    zIndex: 1,
    '&:after': {
      fontSize: 22,
    },
    ['@media screen and (min-width: 768px)']: {
      top: '50%',
      left: '5%',
    },
    ['@media screen and (min-width: 920px)']: {
      left: '5%',
    },
    ['@media screen and (min-width: 1100px)']: {
      left: '10%',
    },
    ['@media screen and (min-width: 1200px)']: {
      left: '12%',
    },
    ['@media screen and (min-width: 1300px)']: {
      left: '15%',
    },
    ['@media screen and (min-width: 1400px)']: {
      left: '16%',
    },
    ['@media screen and (min-width: 1500px)']: {
      left: '22%',
    },
  },
  '& .swiper-button-next': {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    width: 40,
    height: 40,
    right: '0%',
    top: 20,
    zIndex: 1,
    '&:after': {
      fontSize: 22,
    },
    ['@media screen and (min-width: 768px)']: {
      top: '50%',
      right: '5%',
    },
    ['@media screen and (min-width: 920px)']: {
      right: '5%',
    },
    ['@media screen and (min-width: 1100px)']: {
      right: '10%',
    },
    ['@media screen and (min-width: 1200px)']: {
      right: '12%',
    },
    ['@media screen and (min-width: 1300px)']: {
      right: '15%',
    },
    ['@media screen and (min-width: 1400px)']: {
      right: '16%',
    },
    ['@media screen and (min-width: 1500px)']: {
      right: '22%',
    },
  },
}));

export const SdmImageSwiper = ({ images }) => {
  const imageSlides = useMemo(() => {
    return images.map((el, i) => {
      const { src, alt, caption } = el;
      return (
        <SwiperSlide key={`${src}-${i}`} virtualIndex={i}>
          <Box display="flex" flexDirection="column" style={{ width: '100%' }}>
            <Image src={src} alt={alt} />
            {caption && <Caption text={caption} textAlign="center" />}
          </Box>
        </SwiperSlide>
      );
    });
  }, [images]);

  return (
    <StyledSwiper
      modules={[Navigation, Pagination]}
      navigation
      pagination
      slidesPerView={1}
      preventClicks
      preventClicksPropagation
      preventInteractionOnTransition
      loop
    >
      {imageSlides}
    </StyledSwiper>
  );
};
